module.exports = __webpack_public_path__ + "img/pop-camera1.819eff3e.png";